module.exports = __webpack_public_path__ + "static/media/blue-loader.1c704a22.svg";